import React from '/web_modules/react.js';
import styled from '/web_modules/styled-components.js';
import { Navigation, NavigationButton } from './Navigation.js';
import { motion } from '/web_modules/framer-motion.js';
export const HelpButton = styled.button.withConfig({
  displayName: "Header__HelpButton",
  componentId: "mkqys5-0"
})(["font-size:12px;border:none;background:none;color:#353535;text-decoration:underline;display:flex;align-items:center;svg{fill:#353535;width:16px;height:16px;}"]);
const HeaderWrap = styled(motion.header).withConfig({
  displayName: "Header__HeaderWrap",
  componentId: "mkqys5-1"
})(["display:flex;justify-content:space-between;align-items:center;padding:32px 32px 0px 32px;"]);

const HeaderComponent = ({
  onViewChange,
  activeView,
  ...props
}) => /*#__PURE__*/React.createElement(HeaderWrap, props, /*#__PURE__*/React.createElement(Navigation, null, /*#__PURE__*/React.createElement(NavigationButton, {
  key: "playbutton",
  onClick: () => onViewChange('play'),
  isActive: activeView === 'play'
}, "Play"), /*#__PURE__*/React.createElement(NavigationButton, {
  key: "rankingsbutton",
  isActive: activeView === 'rankings',
  onClick: () => onViewChange('rankings')
}, "Ranking")));

export const Header = styled(HeaderComponent).withConfig({
  displayName: "Header",
  componentId: "mkqys5-2"
})([""]);